class SingleErrorResponse {
  /** @param {Object} data
   * @param {string} data.error
   * @param {string} data.reason
   */
  constructor({error, reason}) {
    /** @type {string} */
    this.error = error;
    /** @type {string} */
    this.reason = reason;
  }
}

export default class SearchRouteError extends SingleErrorResponse {
  /** @param {Object} data
   * @param {number} data.status
   * @param {string} data.error
   * @param {string} data.reason
   * @param {SingleErrorResponse[]} errorList
   */
  constructor({status, error, reason, errorList}) {
    super({error, reason});
    /** @type {number} */
    this.status = status;
    this.errorList = errorList
  }
}